// extracted by mini-css-extract-plugin
module.exports = {"main":"app_main__Sc75T"};